import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    data: [],
    page: {
        page: 1,
        size: 10,
        totalPage: 1,
        totalSize: 1,
    }
};

const progressSlice = createSlice({
    name: 'progress',
    initialState,
    reducers: {
        funGetProgress(state, action){
            const { list, page, size, totalPage, totalSize } = action.payload;
            state.data = list.map(( progress ) => {
                return{
                    ...progress,
                }
            });
            state.page = { page, size, totalPage, totalSize };
        }
    },
});

export const progressActions = progressSlice.actions;
export default progressSlice.reducer;